// Custom No Rows Overlay Component
export default class CustomNoRowsOverlay {
  init(params) {
    this.eGui = document.createElement('div');
    this.eGui.className = 'custom-no-rows-overlay absolute inset-0';
    
    // Set up the overlay content
    this.eGui.innerHTML = `
      <div class="h-full p-4 flex flex-row flex-wrap items-center justify-center bg-white gap-2">
        <div class="font-inherit text-xl text-fontcolor font-medium">
          ${params.noRowsMessage}
        </div>
        ${params.createButtonPath ? `
          -
          <a href="${params.createButtonPath}" class="text-blue-400 text-xl font-medium transition-all duration-300 hover:underline cursor-pointer" ${params.createButtonPathIsModal ? 'data-turbo-frame="turbo-modal"' : ''}>
            ${params.createButtonText}
          </a>
        ` : ''}
      </div>
    `;
  }

  getGui() {
    return this.eGui;
  }
} 